export const FILTER_SCHEMA = {
  en: {
    filter_by: "Filter by",
    apply: "Apply",
    filter_alt: "Filter",
    remove_filter: "Remove {key} filter",
    all_status: "All Status",
    all_services: "All Services",
    all_institutions: "All Institutions",
    all_accounts: "All Accounts",
    all_categories: "All Categories",
    all_years: "All Years",
    all_types: "All Types",
    all_statuses: "All Statuses",
    tax_filing: "Tax Filing",
    status: {
      completed: "Completed",
      pending: "Pending",
      canceled: "Canceled",
      succeeded: "Succeeded",
      failed: "Failed",
      active: "Active",
      draft: "Draft",
      in_progress: "In Progress",
      expired: "Expired",
      cancelled: "Cancelled",
    },
    payments: {
      title: "Filter Payments",
    },
    payouts: {
      title: "Filter Payouts",
    },
    filings: {
      title: "Filter Filings",
      service_types: {
        PTF: "Personal Tax Filing",
        BTF: "Business Tax Filing",
        TPC: "Tax Planning/Consulting",
      },
    },
    blog: {
      title: "Filter by Category",
    },
  },
};
